import { useQueryClient } from "@tanstack/react-query";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { useUser } from "../../../contexts/UserContext";
import {
  onlinePaymentKeystore,
  useCanInitiatePayment,
  useInitiatePayment,
  useVerifyPayment,
} from "../../../hooks/online-payment.hooks";

export default function PayOnline({
  applicationId,
}: {
  applicationId: number;
}) {
  return null;
  const userInfo = useUser();
  const qc = useQueryClient();
  const { data: canInitiate, isFetching: fetching } =
    useCanInitiatePayment(applicationId);
  const initiatePaymentMutation = useInitiatePayment();
  const verifyPaymentMutation = useVerifyPayment();

  const onVerifyPayment = (orderId: string) => {
    verifyPaymentMutation.mutate(orderId, {
      onSettled: () =>
        qc.invalidateQueries({
          queryKey: onlinePaymentKeystore.canInitiate(applicationId),
        }),
    });
  };

  const onInitiatePayment = async () => {
    try {
      if (!window.Razorpay) {
        ErrorToast("Error loading payment gateway! Please refresh");
        return;
      }

      const result = await initiatePaymentMutation.mutateAsync(applicationId);
      const orderInfo = result.data.data;

      const options = {
        key: orderInfo.keyId, // Enter the Key ID generated from the Dashboard
        amount: orderInfo.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: "Civic Plan",
        description: "Demand Note Payment",
        order_id: orderInfo.orderId,
        handler: function () {
          onVerifyPayment(orderInfo.orderId);
          SuccessToast("Payment successful!");
        },
        ...(userInfo && {
          prefill: {
            name: userInfo.name,
            ...(userInfo?.email && { email: userInfo.email }),
            ...(userInfo?.mobile && { contact: userInfo.mobile }),
          },
        }),
        theme: { color: "#E9B925" },
      };
      const rzp1 = new window.Razorpay(options);
      rzp1.on("payment.failed", function () {
        ErrorToast(
          "Something went wrong while processing your payment! Please try again."
        );
      });
      rzp1.open();
    } catch {
      //no operation
    }
  };

  const disabled =
    verifyPaymentMutation.isPending ||
    initiatePaymentMutation.isPending ||
    !canInitiate ||
    fetching;

  if (!canInitiate) return null;

  let label = "Pay Online";

  if (verifyPaymentMutation.isPending) {
    label = "Verifying Payment";
  }
  if (initiatePaymentMutation.isPending) {
    label = "Initiating Payment";
  }

  return (
    <>
      <button
        disabled={disabled}
        onClick={onInitiatePayment}
        className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300"
      >
        {label}
      </button>
    </>
  );
}
